export default {"src":"/_next/static/media/icon_prestige.822fe5d5.svg","height":560,"width":560,"blurWidth":0,"blurHeight":0};